module.exports = __webpack_public_path__ + "assets/DNA.6345ec3a.svg";